import { getStorage } from '@/utils/storage';
import i18n from 'i18next';
import { LangEnum } from '@hylaa-npm/ipod';
import { initReactI18next } from 'react-i18next';

interface ILngProps {
	[lng: string]: {
		translation: {
			[key: string]: unknown;
		};
	};
}
const cache: ILngProps = {};

function importAll(r: __WebpackModuleApi.RequireContext) {
	// 处理 key
	r.keys().forEach((key: string) => {
		let lastPoint = key.lastIndexOf('.');
		let lastLevel = key.lastIndexOf('/');
		let firstLevel = key.indexOf('/');
		let index = key.substring(lastLevel + 1, lastPoint);
		let name = key.substring(firstLevel + 1, lastLevel);
		cache[index] = { [name]: r(key).default, ...cache[index] };
	});

	const resources: ILngProps = {};
	for (let key in cache) {
		resources[key] = { translation: { ...cache[key] } };
	}
	return resources;
}

// 获取文件夹
const getFolders = () => {
	return importAll(
		require.context(__dirname, true, /^(\.\/)([a-zA-Z0-9_-])+(\/)([a-zA-Z0-9]+)(\.ts)/),
	);
};

i18n.use(initReactI18next).init({
	resources: getFolders(),
	lng: (getStorage('lang') || LangEnum.ZH).toLowerCase(),
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
